export default __webpack_public_path__ + "static/media/gallery_07.de9294f9.jpg";